// @flow

import type {
  AuthState,
  ResetPasswordOperation,
  ResetPasswordOperator,
} from '../../types'

// Login Operator
import createResetPasswordOperator from 'hfty-auth/src/resetPasswordOperator'

// Module Export Type
type ResetPasswordReducers = { [string]: (state: AuthState, payload: ResetPasswordOperation) => AuthState }

// Reducers
function cancelOperation (state: AuthState): AuthState {
  return {
    ...state,
    resetPasswordOperation: null,
  }
}

function addOperation (state: AuthState, payload: ResetPasswordOperation): AuthState {
  return {
    ...state,
    resetPasswordOperation: payload,
  }
}

function updateOperation (state: AuthState, payload: ResetPasswordOperation): AuthState {
  if (state.resetPasswordOperation) {
    return {
      ...state,
      resetPasswordOperation: {
        ...payload,
        model: {
          ...state.resetPasswordOperation.model,
          ...payload.model,
        },
      },
    }
  } else {
    return {
      ...state,
      resetPasswordOperation: payload,
    }
  }
}

export default function composeResetPasswordReducer (): ResetPasswordReducers {
  const resetPasswordOperator: ResetPasswordOperator = createResetPasswordOperator()

  return {
    [resetPasswordOperator.actionTypes.add()]: addOperation,
    [resetPasswordOperator.actionTypes.updateOperation()]: updateOperation,
    [resetPasswordOperator.actionTypes.cancelOperation()]: cancelOperation,
  }
}
